global.is_local = /localhost/.test(window.location.host) ? 1 : 0;

let domain = global.is_local ? 'http://localhost:6172' : 'https://finapi.itrum.ru';
// domain = 'https://finapi.itrum.ru';

let defConfig = {
    img: '/imgs/logo2.png'
}
let config = {
    local: {login_title: 'Портал Стафер', title: 'Портал Стафер',
        domain: 'http://localhost:6172'},
    stafer: {login_title: 'Портал Стафер', title: 'Портал Стафер',
        domain: 'https://api.stafer.ru',
        img: '/imgs/logo2.png',
    },
    demo: {login_title: 'Портал Стафер (Демо)', title: 'Портал Стафер (Демо)',
        img: '/imgs/logo2.png',
        domain: 'https://api.stafer.ru'},
    fin: {login_title: 'Портал Стафер', title: 'Портал Стафер',
        domain: 'https://finapi.itrum.ru'},

}
let isLocal = global.is_local;
let isStafer = window.location.href.indexOf('stafer.ru') > -1
let isDemo = window.location.href.indexOf('demo.') > -1
config.def = config.fin;

let key = global.is_local ? 'local' : isStafer ? 'stafer' : 'fin';
if (global.is_local) {
    key = 'demo'
}
let opts = config[key] || config.def;
window.env = {
    // domain     : ,
    domain,
    isLocal,
    isStafer,
    isDemo,
    FILE_DOMAIN: domain,
    wo_token: false,
    redirect_after_login: '/admin/users',
    ...defConfig || {},
    ...opts || {}

}

document.title = window.env.title;
